import type React from "react";

import { EmptyState as DefaultEmptyState } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

export const EmptyState: React.FC = () => {
    return (
        <Box paddingY="77px">
            <DefaultEmptyState
                title={translate("si.company-analysis.company-data.card.empty.header")}
                subtitle={translate("si.company-analysis.company-data.card.empty.text")}
            />
        </Box>
    );
};
